/**
 * Formula for calculating the height of grid result as a factor of width
 *
 * @param {number} width grid width in pixels
 * @returns {number} grid height in pixels
 */
export const getGridCellHeight = (width: number): number => {
  return width + 80 // max height of result footer
}
